import React, { useEffect, useState } from 'react'
import './series.css'
import './series2.css'

function Series({serie}) {
    const [series, setSeries] = useState([])
    const getSeriesInfo = async () => {
        const response = await fetch(`https://www.omdbapi.com/?apikey=${process.env.REACT_APP_API_KEY}&t=${serie}`)
        const data = await response.json()
        setSeries(data)
    }

    useEffect(() => {
        getSeriesInfo()
    }, [serie])

    const { Title, Year, Runtime, imdbRating, imdbVotes, Poster, Genre, Plot, Actors } = series

    return (
        <article style={
            {
                backgroundImage: `url(${Poster})`,
                backgroundColor: '#00000080'
            }
        }>

            <section className="card">
                <div className="imgBox">
                    <img src={Poster} alt="" />
                </div>
                <div className="contentBox">
                    <div className="title-box">
                        <h1 className='title'>{Title}</h1>
                        <div className="sub-title">
                            <h3>{Year}</h3>
                            <h3>{Runtime}</h3>
                            <h3>{Genre}</h3>
                        </div>
                    </div>
                    <p className="plot">
                        {Plot}
                    </p>
                    <p className="actors">
                        {Actors}
                    </p>
                    <section className="ratings">
                        <div className="rate">
                            <span>IMDB RATING</span>
                            <h4>{imdbRating}</h4>
                        </div>
                        <div className="votes">
                            <span>IMDB VOTES</span>
                            <h4>{imdbVotes}</h4>
                        </div>
                    </section>
                </div>
            </section>
        </article>
    )
}

export default Series
